module.exports = __webpack_public_path__ + "static/media/hub_line.040d470e.svg";